/**
 * Const with params element
 * SEO component
 * Display SEO information from YOAST with HELMET
 */
/* Import section */
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import React from "react"
import Helmet from "react-helmet"

/* Declaration function */
const SEO = ({ title, description, classHtml, classbody  }) => {
  const { site, defaultImage } = useStaticQuery(query)
  const { pathname } = useLocation()

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    siteLanguage,
  } = site.siteMetadata

  const imageSeo = siteUrl+defaultImage.childImageSharp.gatsbyImageData.images.fallback.src

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: imageSeo,
    url: `${siteUrl}${pathname}`,
  }


  return (
    <Helmet title={seo.title} >
      <html lang={siteLanguage} class={classHtml}/>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      <meta property="og:type" content="website"></meta>
      <meta property="og:url" content={seo.url}/>
      <meta property="og:title" content={seo.title}/>
      <meta property="og:description" content={seo.description}/>
      <meta property="og:image" content={seo.image}/>
      <meta property="og:locale" content={siteLanguage} />


      <meta name="twitter:card" content="summary_large_image"/>
      <meta property="twitter:domain" content="hellohealth.com" />
      <meta property="twitter:url" content={seo.url}/>
      <meta name="twitter:title" content={seo.title}/>
      <meta name="twitter:description" content={seo.description}/>
      <meta name="twitter:image" content={seo.image} />

      {classbody && <body className={classbody} />}

    </Helmet>
  )
}


export const query = graphql`
  query {
    site {
      siteMetadata {
        defaultTitle
        defaultDescription
        siteUrl
        siteLanguage
      }
    }
    defaultImage: file(relativePath: { eq: "og_hellohealth.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, formats: [AUTO])
      }
    }
  }
`

/* Export function */
export default SEO
